export default "__VITE_ASSET__MW28xQ_8__"